import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { AuthLoginField } from '../models/environment.models';

@Injectable({ providedIn: 'root' })
export class AuthConfigService {
  readonly enabled = environment.auth.enabled;
  readonly requireLogin = environment.auth.requireLogin;
  readonly enforcePermissions = environment.auth.enforcePermissions;
  readonly loginField: AuthLoginField = environment.auth.loginField;

  readonly bypassLogin = !this.requireLogin;
  readonly bypassPermissions = !this.enforcePermissions;
}
